import React, { useState, useEffect, useContext } from 'react';
import { Backdrop, CircularProgress, Box, Snackbar, Alert,  Link } from '@mui/material';
import LinkedappBackend from '../../services/LinkedappBackend';
import { CustomerDataContext } from '../context/CustomerDataProvider';
import pfeilrechts from '../../assets/images/pfeilrechts.svg';
import {loadSessionData} from '../../util/store';
interface Props { }



const Unsubscribe: React.FC<Props> = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined as string | undefined);
    const { customer } = useContext(CustomerDataContext);

    

    useEffect(() => {
        if (loading === true) {
            setError(undefined);
            if (customer?.partnerNo && customer?.firstname && customer?.lastname && customer?.email) {
                LinkedappBackend.getLinkedAppLinkUnsubscribe(customer?.partnerNo ?? "", customer?.firstname ?? "", customer?.lastname ?? "", customer?.email ?? "", "").then(response => {
                    if (response?.linkUrl) {
                        window.location.href = response?.linkUrl;
                    }
                    else {
                        setLoading(false);
                        setError("Der Link konnte nicht erstellt werden. Bitte prüfen Sie, ob Sie sich bereits vom digitalen Postfach abgemeldet haben.");
                    }
                }).catch((e) => {
                    console.log("Error", e);
                    setLoading(false);
                    setError("Die Abmeldung konnte nicht ausgeführt werden. Bitte versuchen Sie es erneut.");
                })
            }
            else {
                setLoading(false);
                setError("Die Abmeldung konnte nicht ausgeführt werden.");
            }
        }
    }, [loading, customer?.email, customer?.firstname, customer?.lastname, customer?.partnerNo]);


    function getAbmeldeLink(){
        let cid = loadSessionData("cid");
        return "/abmelden?cid=" + cid;
    }

    return <>
        {<Snackbar open={error !== undefined} autoHideDuration={5000} onClose={() => setError(undefined)}>
            <Alert onClose={() => setError(undefined)} severity="error" sx={{ width: '100%' }}>
                {error}
            </Alert>
        </Snackbar>}
        <Backdrop sx={{ color: '#fff', zIndex: 9999 }} open={loading} >
            <Box sx={{ display: 'block', textAlign: 'center' }}>
                <CircularProgress color="inherit" />
                <br />
                <a href="/" onClick={(e) => {
                    e.preventDefault();
                    setLoading(false);
                }}>Abbrechen</a>
            </Box>
        </Backdrop>
        {customer && <>

            <Link sx={{ display: 'flex-inline', textDecoration: 'none' }} href={getAbmeldeLink()}>
            <Box sx={{ fontSize: "1.0rem", display: 'flex-inline'  }}><img src={pfeilrechts} alt="Pfeil" className={"aktionPfeilRechts"} /> Vom digitalen Versand abmelden</Box>
            </Link></>}
    </>
}

export default Unsubscribe;